(function (angular) {
  "use strict";

  angular.module("Toyota.Directives").directive("tyPricingGradeSelector", [
    "$window",
    "HttpPendingRequestsService",
    function ($window, HttpPendingRequestsService) {
      var controller = [
        "$scope",
        "$element",
        "$timeout",
        "Range",
        "PricingPageAnalyticsService",
        function ($scope, $element, $timeout, Range, PricingPageAnalyticsService) {
          var ctl = this;
          var initialGradeIdInitialised = false;
          var gradeBaseDriveawayPrices = [];

          function init() {
            $scope.$watch("tyPricingGradeSelector.grades", function (grades) {
              if (!grades) {
                throw new Error("tyPricingGradeSelector: tyPricingGradeSelector.grades is empty");
              }

              if (grades.length > 0) {
                var initialGrade = grades.find(function (grade) {
                  return grade.gradeId === ctl.initialGradeId;
                });

                if (!initialGrade) {
                  initialGrade = grades[0];
                }

                selectInitialGrade(initialGrade);

                $timeout(function () {
                  updateScrollPosition();
                });
              }
            });

            $scope.$watch("tyPricingGradeSelector.gradeId", function (gradeId) {
              if (initialGradeIdInitialised) {
                HttpPendingRequestsService.cancelAll();
              }

              initialGradeIdInitialised = true;
              PricingPageAnalyticsService.setGrade(gradeId);
              emitChange(gradeId);
            });
          }

          $scope.$on("grade-change", function (event, gradeId) {
            ctl.gradeId = gradeId;
            emitChange(gradeId);
          });

          $scope.$on("did-detect-mouse", function () {
            updateScrollPosition();
          });

          ctl.$onInit = init;

          function emitChange(gradeId) {
            var selectedGrade = ctl.grades.find(function (grade) {
              return grade.gradeId === gradeId;
            });
            ctl.showIndicativeDriveawayText = selectedGrade.showIndicativeDriveawayText;
            ctl.indicativeDriveawayText = selectedGrade.indicativeDriveawayText;
            ctl.onGradeChange(gradeId);
          }

          function selectInitialGrade(initialGrade) {
            ctl.gradeId = initialGrade.gradeId;
            ctl.showIndicativeDriveawayText = initialGrade.showIndicativeDriveawayText;
            ctl.indicativeDriveawayText = initialGrade.indicativeDriveawayText;
          }

          function updateScrollPosition(animationDuration) {
            var $gradeSelectorItems = $element.find(".ty-pricing-grade-selector-item");
            var $selectedItem = $gradeSelectorItems.filter(":has(> :checked)");
            if ($selectedItem.length === 0) {
              return;
            }

            // align left and add correct amount of padding
            var container = $element.closest(".container");
            var windowWidth = angular.element($window).width();
            var leftPadding = (windowWidth - container.width()) / 2;

            var selectedItem = $selectedItem[0].getBoundingClientRect();
            var scrollAmount = selectedItem.left;
            var $gradeItemsContainer = $element.find(".ty-pricing-grade-selector__items");
            var currentScrollPosition = $gradeItemsContainer.scrollLeft();
            var scrollToPosition = currentScrollPosition + scrollAmount - leftPadding;

            $gradeItemsContainer.animate({ scrollLeft: scrollToPosition }, animationDuration);
          }

          $scope.$on("gradeBaseDriveawayPrice", function (event, gradeIdAndDriveawayPrice) {
            var grade = gradeBaseDriveawayPrices.find(function (gradePrice) {
              return gradePrice.gradeId === gradeIdAndDriveawayPrice.gradeId;
            });

            if (!grade && gradeIdAndDriveawayPrice.driveawayPrice) {
              gradeBaseDriveawayPrices.push(gradeIdAndDriveawayPrice);
            }
          });

          ctl.triggerGradeActiveSelectionAnalyticsEvent = function (gradeId) {
            var grade = Range.getGradeByIdFromCache(gradeId);

            PricingPageAnalyticsService.setGrade(gradeId);

            var analyticsData = {
              eventCategory: "pricing",
              eventAction: "button - grade",
              eventLabel: grade.name,
            };

            var price = gradeBaseDriveawayPrices.find(function (gradePrice) {
              return gradePrice.gradeId === gradeId;
            });

            if (price && price.driveawayPrice) {
              analyticsData.basePrice = price.driveawayPrice;
            }

            PricingPageAnalyticsService.triggerAnalytics("gaClick", analyticsData);
          };
        },
      ];

      var link = function ($scope, $element, $attrs, $ctrl, $transclude) {
        $transclude($scope, function (clone) {
          $element.append(clone);
        });
      };

      return {
        bindToController: {
          grades: "<tyPricingGradeSelectorGrades",
          onGradeChange: "<tyPricingGradeSelectorOnGradeChange",
          initialGradeId: "<tyPricingGradeSelectorInitialGradeId",
        },
        controller: controller,
        controllerAs: "tyPricingGradeSelector",
        link: link,
        restrict: "A",
        scope: {},
        transclude: true,
      };
    },
  ]);
})(window.angular);
